import {
  RECIPE_SUPPLIER_TITLE,
  RECIPE_TYPE,
} from 'src/utils/stockTakeRecipeProduct'

export const ADD_PRODUCT_SUBMIT_FIELD_KEYS = ['inStock', 'wastage']

export const ADD_PRODUCT_FOCUS_FIELD = {
  oms: 'omsSearch',
  custom: 'title',
  recipe: 'recipeSearch',
}

export const getAddProductFocusField = mode => {
  if (mode === 'oms') return ADD_PRODUCT_FOCUS_FIELD.oms
  if (mode === 'recipe') return ADD_PRODUCT_FOCUS_FIELD.recipe
  return ADD_PRODUCT_FOCUS_FIELD.custom
}

export const buildEmptyAddProductFields = (
  currentMode,
  recipePriceMode = 'Portion',
) => ({
  title: '',
  type: currentMode === 'recipe' ? RECIPE_TYPE : '',
  price: 0,
  OMSPrice: 0,
  supplierTitle: currentMode === 'recipe' ? RECIPE_SUPPLIER_TITLE : '',
  size: currentMode === 'recipe' ? '1' : '',
  UoM: currentMode === 'recipe' ? 'Portion' : '',
  sku: '',
  hasVat: false,
  inStock: 0,
  wastage: 0,
  lastQuantity: 0,
  recipeId: null,
  recipePortionsPerBatch: null,
  recipePriceMode: currentMode === 'recipe' ? recipePriceMode : 'Portion',
})

export const shouldSubmitAddProductFromField = fieldKey =>
  ADD_PRODUCT_SUBMIT_FIELD_KEYS.includes(fieldKey)
